var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_2848",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_2848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16C13.75 16 14.8125 15.5625 15.6875 14.6875C16.5625 13.8125 17 12.75 17 11.5C17 10.25 16.5625 9.1875 15.6875 8.3125C14.8125 7.4375 13.75 7 12.5 7C11.25 7 10.1875 7.4375 9.3125 8.3125C8.4375 9.1875 8 10.25 8 11.5C8 12.75 8.4375 13.8125 9.3125 14.6875C10.1875 15.5625 11.25 16 12.5 16ZM12.5 14.2C11.75 14.2 11.1125 13.9375 10.5875 13.4125C10.0625 12.8875 9.8 12.25 9.8 11.5C9.8 10.75 10.0625 10.1125 10.5875 9.5875C11.1125 9.0625 11.75 8.8 12.5 8.8C13.25 8.8 13.8875 9.0625 14.4125 9.5875C14.9375 10.1125 15.2 10.75 15.2 11.5C15.2 12.25 14.9375 12.8875 14.4125 13.4125C13.8875 13.9375 13.25 14.2 12.5 14.2ZM12.5 19C10.0667 19 7.85 18.3208 5.85 16.9625C3.85 15.6042 2.4 13.7833 1.5 11.5C2.4 9.21667 3.85 7.39583 5.85 6.0375C7.85 4.67917 10.0667 4 12.5 4C14.9333 4 17.15 4.67917 19.15 6.0375C21.15 7.39583 22.6 9.21667 23.5 11.5C22.6 13.7833 21.15 15.6042 19.15 16.9625C17.15 18.3208 14.9333 19 12.5 19Z",
    fill: "#4D2481"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFilled);
export default __webpack_public_path__ + "static/media/eye-filled.6d5cd9e898439c20361aebddd9967c56.svg";
export { ForwardRef as ReactComponent };